module.exports = __webpack_public_path__ + "static/media/TableSideHole_Before.61dd7ece.jpg";